export default "__VITE_ASSET__8099ec12__"